import { render } from "./MeetingList.vue?vue&type=template&id=22e482da"
import script from "./MeetingList.vue?vue&type=script&lang=js"
export * from "./MeetingList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__